import React, { useEffect } from "react";
import {
  FaTwitter,
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";  
import aboutImg from '../assets/img/home-about.png'
import Homenew from "./Homenew";
import OurLhome from "./OurLhome";
import OurA from "./OurA";
import TestimonialSection from "./TestimonialSection";
const Home = () => {
   useEffect(() => {
    AOS.init({
      duration: 1000,   
      easing: "ease-in-out",       
    });
  }, []);
  
  return (
    <div>
      {/* hero section */}
      <section className="hero-section text-white d-flex align-items-center" > 
        <div className="container">
          <div className="row">
            <div className="col-lg-12" data-aos="fade-up">
              <p className="tagline">WE HAVE EXPERT ATTORNEY</p>
              <h1 className="fw-bold hero-title">
                Videlicet Law – <span>A Legacy of Legal Excellence </span>
              </h1>
              <button className="btn btn-danger mt-3 px-4 py-2 fw-semibold">
                Meet Our Team
              </button>
            </div>
          </div>
        </div>
        {/* bottom contact section */}
        {/* <div className="hero-contact text-end mt-4">
  <div className="container">
    <div className="d-flex flex-column flex-md-row justify-content-end align-items-center">
      <div className="contact-left me-md-4">
        <p className="mb-0">
          <strong>Mail :</strong>{" "}
          <a href="mailto:videlicetlaw@gmail.com" className="email-link">
            videlicetlaw@gmail.com
          </a>
        </p>
      </div>
      <div className="contact-right d-flex align-items-center mt-2 mt-md-0">
        <p className="mb-0 me-3">
          <strong>Mobile :</strong> (+91)12 354 5368
        </p>
        <div className="social-icons d-flex align-items-center">
          <a href="#"><FaTwitter /></a>
          <a href="#"><FaFacebookF /></a>
          <a href="#"><FaLinkedinIn /></a>
          <a href="#"><FaInstagram /></a>
        </div>
      </div>
    </div>
  </div>
</div> */}{" "}
      </section>

      {/* Expert Legal Support section */}
      <section className="container-fluid py-4 px-5" data-aos="fade-up"  data-aos-delay="100"
>
        <div className="row support-content">
          <div className="col-md-6 support-div-para">
            <span className="support-smallheading">Trust Your Matter to Proven Legal Expertise</span>
            <h4>Comprehensive Legal Support</h4>
            <p>
            We are committed to protecting your rights and advancing your interests with precision and professionalism. <br/>
Whether you seek strategic legal advice, effective representation, or complete case management, our team ensures clarity, accountability, and timely legal support at every stage.<br/>
Our approach is rooted in legal rigor, ethical practice, and client-focused advocacy

            </p>
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 card-first-div">
                {/* 1st card */}
                <div className="card-container text-center p-2">
                  <div className="icon-circle mx-auto mb-3">
                    <i className="bi bi-shield-check"></i> {/* new icon */}
                  </div>
                  <h5 className="card-title">
                    <i className="bi bi-balance-scale me-2 text-danger"></i>{" "}
                    {/* icon beside heading */}
                    Legal Advisory 
                  </h5>
                  <p className="card-text">
                    Comprehensive legal counsel across personal, commercial, and institutional matters
                  </p>
                </div>

                {/* 2nd card */}
                <div className="card-container text-center p-2 mt-3 Attorneys-card">
                  <div className="icon-circle mx-auto mb-3">
                    <i className="bi bi-trophy"></i>
                  </div>
                  <h5 className="card-title">
                    {/* <i className="bi bi-graph-up-arrow me-2 text-danger"></i> */}
                    Proven Outcomes 
                  </h5>
                  <p className="card-text">
                    A results-driven approach focused on achieving effective and sustainable legal outcomes
                  </p>
                </div>
              </div>

              <div className="col-md-6">
                {/* 3rd card */}
                <div className="card-container text-center p-2 Attorneys-card mt-3 mt-md-0">
                  <div className="icon-circle mx-auto mb-3">
                    <i className="bi bi-person-badge"></i>
                  </div>
                  <h5 className="card-title">
                    {/* <i className="bi bi-briefcase me-2 text-danger"></i> */}
                    Experienced Advocates 
                  </h5>
                  <p className="card-text">
                   Seasoned legal professionals delivering trusted advocacy and sound legal guidance
                  </p>
                </div>

                {/* 4th card */}
                <div className="card-container text-center p-2 mt-3">
                  <div className="icon-circle mx-auto mb-3">
                    <i className="bi bi-people mx-2 text-danger"></i>
                  </div>
                  <h5 className="card-title">Client-Centric Approach </h5>
                  <p className="card-text">
                    Tailored legal strategies designed around your specific objectives and concerns
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
       {/* about  */}
        <section className="about-section py-5" style={{ backgroundColor: '#CDE4FF' }} data-aos="fade-up"  data-aos-delay="100">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-5 mb-4 mb-md-0 p-md-0">
            <img
              src={aboutImg}
              alt="Gavel"
              className="img-fluid rounded "
              style={{ maxHeight: '500px', objectFit: 'cover' }}
            />
          </div>
          <div className="col-md-7 home-abut-para">
            <h2 className="fw-bold  mb-3">About Us</h2>
            <p className=" fs-5 mb-0">
             Videlicet Law is a full-service law firm committed to delivering high-quality legal services founded on integrity, precision, and domain expertise. 
            </p>
            <p className=" fs-5">
             Our team of dedicated legal professionals advises and represents individuals, cooperative institutions, businesses, and organizations across a wide spectrum of legal matters.
We adopt a strategic and solution-oriented approach to law, offering tailored legal advice in civil, commercial, constitutional, regulatory, and property-related matters. Our practice is anchored in strong ethical values, rigorous legal analysis, and a deep commitment to protecting our clients’ rights and interests.
At Videlicet Law, we believe in building long-term professional relationships through trust, transparency, and consistent legal excellence

            </p>
            <button className="read-more-btn">
              Read More
            </button>
          </div>
        </div>
      </div>
    </section>
     <Homenew/>
     <OurLhome/>
     <OurA/>
    <TestimonialSection/>
    </div>
  );
};

export default Home;



